import clsx from 'clsx';
import { SHOW_MORE_LABEL } from '../../../../../shared/ui/show-more-toggle';
import { TextActionButton } from '../../../../../shared/ui/text-action';
import { getSelectedKeysForFilterSection } from '../lib/filterHelpers';
import styles from '../FiltersPanel.module.css';
import { FilterOption } from './FilterOption';

export function FilterSection({ title, sectionKey, items, showMore = false, filters, onToggle }) {
  const selected = getSelectedKeysForFilterSection(filters, sectionKey);

  return (
    <section className={clsx(styles.section)}>
      <h3 className={clsx(styles.sectionTitle)}>{title}</h3>
      <div className={clsx(styles.options)}>
        {items.map(({ key, label, count }, index) => (
          <FilterOption
            key={`${title}-${key}-${index}`}
            sectionKey={sectionKey}
            optionKey={key}
            label={label}
            count={count}
            checked={(selected ?? []).map(String).includes(String(key))}
            onToggle={onToggle}
          />
        ))}
      </div>
      {showMore ? <TextActionButton type="button">{SHOW_MORE_LABEL}</TextActionButton> : null}
    </section>
  );
}
